import { useMutation } from "@tanstack/react-query";
import { convertHtmlToSfdt } from "../services/document.service";

/**
 * Hook for converting HTML to SFDT
 */
export const useConvertHtmlToSfdt = () => {
    return useMutation({
        mutationFn: (htmlContent: string) => convertHtmlToSfdt(htmlContent),
        onError: (error) => {
            console.error("Failed to convert HTML to SFDT:", error);
        },
    });
};
